import { CheckCircle2, Mailbox } from "lucide-react";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" }) : "");

function Bar({ label, value, goal, display, testid }) {
  const pct = Math.min(100, Math.round((value / goal) * 100));
  const done = value >= goal;
  return (
    <div data-testid={testid}>
      <div className="flex items-baseline justify-between text-sm">
        <span className="font-semibold text-sam-navy">{label}</span>
        <span className={done ? "font-bold text-sam-green" : "font-bold text-sam-navy"} data-testid={`${testid}-value`}>{display}</span>
      </div>
      <div className="mt-1.5 h-3 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-700 ${done ? "bg-sam-green" : "bg-sam-crimson"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default function CardProgressMeter({ p }) {
  if (!p) return null;
  const spotsLeft = Math.max(0, p.need_spots - p.paid);
  const dollarsLeft = Math.max(0, p.need_amount - p.paid_amount);
  return (
    <div className="mb-6 rounded-2xl border border-border bg-white p-5 shadow-sm" data-testid="card-progress-meter">
      <div className="flex items-center gap-2 mb-1">
        {p.ready ? <CheckCircle2 className="h-5 w-5 text-sam-green" /> : <Mailbox className="h-5 w-5 text-sam-crimson" />}
        <h3 className="font-display font-black text-sam-navy text-lg" data-testid="card-progress-title">
          {p.ready ? "This card is set to mail" : "How close this card is to mailing"}
        </h3>
      </div>
      <p className="text-xs text-sam-slate mb-4" data-testid="card-progress-rule">
        A card mails once it has {p.need_spots}+ paid spots and ${p.need_amount.toLocaleString()}+ in paid ad sales
        {p.deadline ? `, both by ${fmtDate(p.deadline)} (15 days before the ${fmtDate(p.mail_date)} mailing)` : ""}.
        If it falls short, paid advertisers carry over to the next drop.
      </p>
      <div className="space-y-4">
        <Bar label="Paid spots" value={p.paid} goal={p.need_spots} display={`${p.paid} / ${p.need_spots}`} testid="card-progress-spots" />
        <Bar label="Paid ad sales" value={p.paid_amount} goal={p.need_amount} display={`$${p.paid_amount.toLocaleString()} / $${p.need_amount.toLocaleString()}`} testid="card-progress-sales" />
      </div>
      {!p.ready && (
        <p className="mt-4 text-sm font-semibold text-sam-crimson" data-testid="card-progress-remaining">
          {[spotsLeft > 0 && `${spotsLeft} more paid spot${spotsLeft === 1 ? "" : "s"}`, dollarsLeft > 0 && `$${dollarsLeft.toLocaleString()} more in sales`].filter(Boolean).join(" and ")} to go.
        </p>
      )}
    </div>
  );
}
